import { BillingStatus } from '../../enums';
import { AdherentFarmTrialStatus } from '../networkOrgs';
import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
export const mockedNetworkOrgs = {
    convertedAt: '1600552800',
    id: 1,
    isTrial: false,
    networkId: 1,
    org: {
        id: 1,
        billingStatus: BillingStatus.expert,
        companyName: 'My company name',
        membershipCode: 'ABC',
        membersCount: 1,
        name: 'org',
        owner: {
            email: 'owner@weenat.com',
            fullName: 'Owner Orga',
            phone: '0623232323'
        },
        address: {
            addressLine1: '9 mocked street',
            addressLine2: '2nd plot',
            city: 'Nantes',
            countryCode: 'FR',
            zipCode: '44000'
        },
        siret: '1234567890123'
    },
    since: '1600552800',
    until: '33157461600',
    trialStatus: AdherentFarmTrialStatus.over
};
const response = mockedPaginatedResponse([mockedNetworkOrgs]);
const mock = {
    get: mockedRequester(mockedNetworkOrgs, 'networkOrgs.get'),
    getAllPagesStillActive: mockedRequester([mockedNetworkOrgs], 'networkOrgs.getAllPagesStillActive'),
    getMany: mockedRequester(response, 'networkOrgs.getMany'),
    getPage: mockedRequester(response, 'networkOrgs.getPage'),
    convertToPaidNetwork: mockedRequester(undefined, 'networkOrgs.convertToPaidNetwork'),
    remove: mockedRequester(undefined, 'networkOrgs.remove'),
    download: mockedRequester({}, 'networkOrgs.download')
};
export default mock;
